/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CreatePayoutRequestMethod = typeof CreatePayoutRequestMethod[keyof typeof CreatePayoutRequestMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePayoutRequestMethod = {
  UNIONPAY: 'UNIONPAY',
  BANK_SWIFT: 'BANK_SWIFT',
  ALIPAY: 'ALIPAY',
} as const;
